module.exports = __webpack_public_path__ + "jab/media/data-file.9a34aa73.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/data-file.svg
// module id = 1473
// module chunks = 0